import React from 'react';
import LanguageSelector from './components/LanguageSelector';
import { LocalizationProvider } from './context/LocalizationContext';
import ROICalculator from './components/ROICalculator';
import './App.css';

import { useLocalization } from './context/LocalizationContext';
import { Routes, Route } from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';

function App() {
  return (
    <LocalizationProvider>
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </LocalizationProvider>
  );
}

function MainContent() {
  const { t, locale } = useLocalization();
  return (
    <div className="theme-olyra page-background min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
          {/* Header with logo and language selector */}
          <div className="mb-10 flex items-center justify-between">
            <img
              src="https://olyra.ai/images/header-logo.png"
              alt="Olyra"
              className="h-8 w-auto"
              loading="eager"
              decoding="async"
            />
            <div className="ml-auto">
              <LanguageSelector />
            </div>
          </div>

          {/* Shared inner wrapper so header aligns with form */}
          <div className="max-w-2xl mx-auto">
            <div className="mb-8">
              <h1 className="text-3xl font-extrabold text-white sm:text-4xl">
                {t('topHeading')}
              </h1>
              <p className="mt-3 text-xl text-subtle sm:mt-4">
                {t('topSubtitle')}
              </p>
            </div>

            <ROICalculator />
          </div>
          
          <footer className="mt-12 text-center text-sm text-subtle">
            <p> © {new Date().getFullYear()} <a href="https://www.olyra.ai" target="_blank" rel="noopener noreferrer" className="brand-text-link underline">Olyra.ai</a>. {t('allRightsReserved')}</p>
            <p className="mt-2">
              <a
  href={`https://www.olyra.ai/privacy-${locale.toLowerCase()}`}
  target="_blank"
  rel="noopener noreferrer"
  className="brand-text-link underline"
>{t('privacyPolicy')}</a>
              <span className="mx-2">•</span>
              <a
  href={`https://www.olyra.ai/terms-${locale.toLowerCase()}`}
  target="_blank"
  rel="noopener noreferrer"
  className="brand-text-link underline"
>{t('termsOfService')}</a>
            </p>
          </footer>
        </div>
      </div>
  );
}

export default App;
